"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toTypedElementArray = exports.isTypedElement = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const arrayHelpers_1 = require("../utils/arrayHelpers");
// -------------------------------------------------------------------------------------------
// --- Functions ---
/**
 * Type guard - that x is a Typed Element, and optionally of type 'typename'
 */
const isTypedElement = (x, typename) => {
    const isEl = !!x && '__typename' in x && typeof x.__typename === 'string';
    if (!isEl)
        return false;
    return typename ? (0, arrayHelpers_1.makeNonNullableArray)(typename).includes(x.__typename) : true;
};
exports.isTypedElement = isTypedElement;
/**
 * Convert {@link MaybeArrayOf}`<T>` into an array of Typed Elements, optionally of type `typename`
 */
const toTypedElementArray = (maybeItems, typename) => {
    const arr = (0, arrayHelpers_1.makeNonNullableArray)(maybeItems);
    return arr.filter((x) => (0, exports.isTypedElement)(x, typename));
};
exports.toTypedElementArray = toTypedElementArray;
// type TestCallbacks = typeof TEST.testCallbacks;
// type Test1 = Sanitised<TEST.Inputs, TestCallbacks>;
// type Test2 = Test1['childThings'];
// type Test1 = TypenameToPropKeysMap<TEST.InputsIntersection>;
// type Test1 = PropKeys<TEST.InputsIntersection>;
// type Test2 = PropKeys<TEST.Inputs>;
// type Test1 = ElWithProp<TEST.Inputs, 'date'>;
// type Test2 = ElWithProp<TEST.Inputs, 'kind'>;
// type Test3 = ElWithProp<TEST.Inputs, 'uid'>;
// type Test1 = PropType<TEST.Inputs, 'kind'>;
// type Test2 = PropCallback<TEST.Inputs, 'kind'>;
// type Test1 = BuiltInPropCallback<TEST.Inputs, 'childThings'>;
// type Test2 = BuiltInPropCallback<TEST.Inputs, 'kind'>;
// type Test2 = PropCallbacks<TEST.Inputs>;
